module.exports = {"370902001":"岱庙街道","370902002":"财源街道","370902003":"泰前街道","370902004":"上高街道","370902005":"徐家楼街道","370902100":"省庄镇","370902101":"邱家店镇","370902202":"大津口乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370902.json
// module id = 1325
// module chunks = 0